import { useEffect, useState } from "react";
import { api } from "../api";
import ProductCard from "../components/ProductCard";
import { useCart } from "../context/CartContext";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Wishlist() {
  const { wishlist } = useCart();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    (async () => {
      if (!wishlist.length) {
        setProducts([]);
        return;
      }
      try {
        const { data } = await api.get("/api/products", { params: { limit: 500 } });
        setProducts(data.filter((p) => wishlist.includes(p.id)));
      } catch {
        setProducts([]);
      }
    })();
  }, [wishlist]);

  return (
    <main className="page" data-testid="wishlist-page">
      <div className="page-head">
        <span className="eyebrow">Saved for later</span>
        <h1>
          Your <em>wishlist.</em>
        </h1>
        <p>Pieces you've held close. When you're ready, add to cart or enquire on WhatsApp.</p>
      </div>
      {products.length ? (
        <div className="product-grid">
          {products.map((p) => (
            <ProductCard product={p} key={p.id} />
          ))}
        </div>
      ) : (
        <div className="empty">
          <p data-testid="empty-wishlist-message" style={{ marginBottom: 24 }}>Your saved looks will appear here.</p>
          <Link to="/shop" className="btn btn-primary">Explore the collection <ArrowUpRight size={16} /></Link>
        </div>
      )}
    </main>
  );
}
